import React from 'react'

import { CollectionsSalesAnalyticsIcon } from '@components/icons/CollectionsSalesAnalyticsIcon'
import { CommentIcon } from '@components/icons/CommentIcon'
import { EyeSalesAnalyticsIcon } from '@components/icons/EyeSalesAnalyticsIcon'
import { LoveSalesAnalyticsIcon } from '@components/icons/LoveSalesAnalyticsIcon'
import { OverviewHeaderAcceptProps, OverviewHeaderProps } from './interface'

export function withOverviewHeader(Component: React.FC<OverviewHeaderProps>) {
  function WithOverviewHeader({
    viewCount,
    likeCount,
    shelfAddedCount,
    commentCount,
    ...props
  }: OverviewHeaderAcceptProps) {
    const reportList = [
      {
        id: 1,
        text: 'ยอดวิว',
        value: viewCount,
        icon: (
          <EyeSalesAnalyticsIcon
            className='text-primary mobile:w-[27px] mobile:h-[27px]'
            width='56px'
            height='56px'
          />
        ),
      },
      {
        id: 2,
        text: 'กำลังใจ',
        value: likeCount,
        icon: (
          <LoveSalesAnalyticsIcon
            className='text-red mobile:w-[27px] mobile:h-[27px]'
            width='56px'
            height='56px'
          />
        ),
      },
      {
        id: 3,
        text: 'การเพิ่มเข้าชั้น',
        value: shelfAddedCount,
        icon: (
          <CollectionsSalesAnalyticsIcon
            className='text-primary mobile:w-[27px] mobile:h-[27px]'
            width='56px'
            height='56px'
          />
        ),
      },
      {
        id: 4,
        text: 'ความคิดเห็น',
        value: commentCount,
        icon: (
          <CommentIcon
            className='text-primary mobile:w-[27px] mobile:h-[27px]'
            width='56px'
            height='56px'
          />
        ),
      },
    ]
    const newProps = {
      ...props,
      viewCount,
      likeCount,
      shelfAddedCount,
      commentCount,
      reportList,
    }
    return <Component {...newProps} />
  }
  return WithOverviewHeader
}
